import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'marv-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  imports: [ReactiveFormsModule],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class MarvCheckboxComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelCheckbox: string = '';
    @Input({alias : 'value', required : false}) valueCheckbox: string|number = 1;
    @Input({alias : 'formName', required : false}) formName: string|number = '';
    @Input({alias : 'inline', required : false}) inlineCheckbox: boolean = false;
    @Input({alias : 'labelPlacement', required : false}) labelPlacement: 'start'|'end' = 'start';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MSG_ERROR_FIELD_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;

    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {}

    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
}
